import { render } from "./IntroMain.vue?vue&type=template&id=8db9c402&scoped=true"
import script from "./IntroMain.vue?vue&type=script&lang=js"
export * from "./IntroMain.vue?vue&type=script&lang=js"

import "./IntroMain.vue?vue&type=style&index=0&id=8db9c402&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db9c402"]])

export default __exports__